import { HttpClient, HttpHeaders } from '@angular/common/http';

import { StorageService } from 'src/app/services/storage/storage.service';
import { environment } from 'src/environments/environment';
import { Injectable } from '@angular/core';
import { ModalAlertsComponentPayment } from 'src/app/pages/private/payment-terminal/payment-terminal.page'
import { ModalController } from '@ionic/angular';

@Injectable({
  providedIn: 'root'
})
export class PaymentTerminalService {
  baseUrl = environment.gluky?.pointsNewApiBasePath;
  IsOpen = false;
  constructor(
    private storageServices: StorageService,
    private http: HttpClient,
    private modalController: ModalController,

  ) { }

  async getCategories() {
    return new Promise((resolve, reject) =>
      this.http
        .get(`${this.baseUrl}/front/categories`)
        .subscribe(
          async (res) => {
            resolve(res);
          },
          (err) => {
            reject(err);
          }
        )
    );
  }
  async canExchange(balance) {
    return new Promise((resolve, reject) =>
      this.http
        .get(`${this.baseUrl}/front/user/can-exchange?balance=${balance}`)
        .subscribe(
          async (res) => {
            resolve(res);
          },
          (err) => {
            reject(err);
            console.log(err);
            
            if (err.error.code === "USER_ACCOUNT_NOT_FOUND") {
              this.openModal(2);
            }
          }
        )
    );
  }
  async getBrands() {
    return new Promise((resolve, reject) =>
      this.http
        .get(`${this.baseUrl}/front/brands`)
        .subscribe(
          async (res) => {
            resolve(res);
          },
          (err) => {
            reject(err);
          }
        )
    );
  }
  async getBrandsByCategory(idCategory) {
    return new Promise((resolve, reject) =>
      this.http
        .get(`${this.baseUrl}/front/brands?categoryId=${idCategory}`)
        .subscribe(
          async (res) => {
            resolve(res);
          },
          (err) => {
            reject(err);
          }
        )
    );
  }

  async getBrandDetail(idBrand, withLocations = true) {
    return new Promise((resolve, reject) =>
      this.http
        .get(`${this.baseUrl}/front/brands/${idBrand}?withLocations=${withLocations}`)
        .subscribe(
          async (res) => {
            resolve(res);
          },
          (err) => {
            reject(err);
          }
        )
    );
  }

  async putRegisterUser(data){
    return new Promise((resolve, reject) =>
      this.http
        .put(`${this.baseUrl}/front/user/register`,data )
        .subscribe(
          async (res:any) => {
            resolve(res);
          },
          (err) => {
            console.error('putRegisterUser',err);
            reject(err);
          }
        )
    );
  }

  async openModal(msg) {
    console.log('open msg ', msg);
    if (!this.IsOpen) {
      const modal = await this.modalController.create({
        component: ModalAlertsComponentPayment,
        id: "redemption-modal",
        componentProps: {
          data:msg,
          onClose: async (data) => {
            await modal.dismiss({ dismissed: true });
          }
        },
        cssClass:'my-custom-height-modal-redemption',
        backdropDismiss:false,
        swipeToClose:false
      });

      modal.onDidDismiss().then(() => {
        this.IsOpen = false
        this.closeAllModalsRedemption();
      })
      return await modal.present().then(() => {     
        this.IsOpen = true
        const el =  document.getElementsByTagName('ion-modal')
        for (let i = 0; i < el.length; i++) {
          const element = el[i];
          if (element.id == 'redemption-modal') {
            element.style.setProperty('--height', '40vh');
          } 
        }
      });
    }
  }

  closeAllModalsRedemption(){
    const alerts = document.getElementsByTagName('ion-modal')
    for (let i = 0; i < alerts.length; i++) {
      const element = alerts[i];
      if (element.id == 'redemption-modal') {
         element.remove();
      } 
      element.dismiss();
      
    }
  }

}
